import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { useAuth } from './AuthContext';

export interface GameTheme {
  id: string;
  name: string;
  slug: string;
  color: string;
  mappedPalette?: string;
}

export const GAMES: GameTheme[] = [
  { id: '39c3bf99-927a-4017-99f3-a22b10d9a861', name: 'Forza Motorsport', slug: 'forza-motorsport', color: '#F9CA36', mappedPalette: 'Yellow' },
  { id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', name: 'Forza Horizon 6', slug: 'forza-horizon-6', color: '#ffabf3', mappedPalette: 'Pink' },
  { id: '3d39a71f-594a-451a-bf8d-721227eed5bb', name: 'Automobilista 2', slug: 'ams2', color: '#DC2937', mappedPalette: 'Red Latam' },
  { id: '8f2e4b7a-9c1d-4e3f-a5b2-7d8c9e0f1a2b', name: 'Project Motor Racing', slug: 'project-motor-racing', color: '#ead346', mappedPalette: 'Yellow Latam' },
  { id: '5b82c61e-1f7c-473d-82d2-43ee7d8c224c', name: 'Assetto Corsa', slug: 'ac', color: '#9c1d27', mappedPalette: 'Red' },
  { id: 'c7d8e9f0-a1b2-4c3d-8e4f-5a6b7c8d9e0f', name: 'Gran Turismo', slug: 'gran-turismo', color: '#4FC3F7', mappedPalette: 'GT Blue' },
];

interface GameContextType {
  selectedGame: GameTheme;
  setSelectedGame: (game: GameTheme) => void;
}

export const GameContext = createContext<GameContextType | undefined>(undefined);

export const GameProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { emssUser } = useAuth();
  const [selectedGame, setSelectedGame] = useState<GameTheme>(GAMES[0]);

  // Sync with user priority game preference
  useEffect(() => {
    if (emssUser?.priority_game_id) {
      const preferred = GAMES.find(g => g.id === emssUser.priority_game_id);
      if (preferred) {
        setSelectedGame(preferred);
      }
    }
  }, [emssUser?.priority_game_id]);

  return (
    <GameContext.Provider value={{ selectedGame, setSelectedGame }}>
      <div data-game={selectedGame.slug}>
        {children}
      </div>
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
};
